import React from 'react';
import { faBoxesStacked, faMapLocationDot, faChartPie,faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import issbyover from '../assets/issby-over.png';
import issbyunder from '../assets/issby-under.png';
import issbyright from '../assets/issby-just-right.png';
import './Home.css'

function Intro2() {
  return (
    <div className="container">
    <div className="container-mobile">
      <h3>This website is best viewed on a laptop.</h3>
      <p>Hence, the content is disabled. Please view it on a desktop or a laptop screen</p>
    </div>
      <div className="container-desktop">
      {/* Main Heading Area */}
      <header>
        <h1>Inter Store Stock Balancing/ISSBY</h1>
            <h2><i>REDUCING RETAILER RISK...</i></h2>
        <p>
        In an independent footwear store, there are always three kinds of inventory ...
</p>
      </header>
      {/* Section 1: Overview & Purpose */}
      {/* Section 2: Key Modules */}
      <section className="modules-section">
        <div className="grid">
          {/* Module 1: Item Management */}
          <div className="card card-blue">
            <div className="card-icon" style={{ color: '#6366f1' }}>
              <img src={issbyright} alt="Logo" width="130em" height="80em"/>
            </div>
            <h3>JUST RIGHT</h3>
            <p>
Products that have an optimal stock level to meet the current rate of sale.
            </p>
          </div>
          {/* Module 3: Reporting & Analytics */}
          <div className="card card-orange">
            <div className="card-icon" style={{ color: '#f59e0b' }}>
              <img src={issbyunder} alt="Logo" width="130em" height="80em"/>
            </div>
            <h3>UNDER</h3>
            <p>
Products that are in short supply and need restocking due to close out or discontinuation            </p>
          </div>
          {/* Module 2: Location Tracking */}
          <div className="card card-teal">
            <div className="card-icon" style={{ color: '#14b8a6' }}>
              <img src={issbyover} alt="Logo" width="130em" height="80em"/>
            </div>
            <h3>OVER</h3>
            <p>Products that are overstocked and need to be sold to reduce excess inventory.</p>
          </div>
        </div>
      </section>
      <section className="overview-section">
      <p>
        With ISSBY, retailers are able to place monthly product listings inside ISSBY’s Matching Tool found on <b>page 3</b>, the goal being to identify SKUs  that are “over here” and “under there”, or vice versa. 

          </p>
          <p>
            On the 15th of every month, ISSBY emails the Summary of Overs and Unders Report to all members of the network enabling free access. This monthly report enables retailers to quickly and easily “see the marketplace of Overs and Unders.” That is, retailers are able to focus on specific brands or styles to see if there are listings that should be placed inside the Matching Tool.
          </p>

      </section>
      <div style={{display: 'flex', justifyContent: 'center', gap: '20em'}}>
      <h2 className="shimmer" style={{marginLeft: '2em'}}><i>FEWER MARKDOWNS</i></h2>
      <h2 className='shimmer'><i>SALES INCREASES</i></h2>
      </div>

        <Link to="/user" style={{ textDecoration: 'none', color: '#000', margin: '80%' }}>
        <button type="submit" style={{ padding: '10px 20px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
          Proceed to next page
        </button>
</Link>
      <div style={{display: 'flex', justifyContent: 'center', gap: '20em'}}>
      <h4 style={{marginLeft: '2em'}}>Page 1 of 3</h4>
      </div>
      </div>
    </div>
  );
}

export default Intro2;
